module.exports = __webpack_public_path__ + "img/labor_data_of_the_contractor.4d5b970d.svg";